var map = {
	"./project-1.jpg": 9225,
	"./project-10.jpg": 5429,
	"./project-11.jpg": 7560,
	"./project-12.jpg": 1367,
	"./project-13.jpg": 5530,
	"./project-14.jpg": 73,
	"./project-2.jpg": 5518,
	"./project-3.jpg": 299,
	"./project-4.jpg": 3976,
	"./project-5.jpg": 9989,
	"./project-6.jpg": 3738,
	"./project-7.jpg": 8199,
	"./project-8.jpg": 484,
	"./project-9.jpg": 8529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6620;